import { ServiceFetch } from '../service-fetch'

export default class PointsTransectionModel extends ServiceFetch {
    getPointsTransectionBy = (data) => this.authFetch({
        url: 'points-transection/getPointsTransectionBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    
    runPointsTransectionMaintenance = (data) => this.authFetch({
        url: 'points-transection/runPointsTransectionMaintenance',
        method: 'POST',
        body: JSON.stringify(data),
    })
}